module.exports = __webpack_public_path__ + "static/abanca_grey-b3fb997496108b70003005adae68698c.svg";